import React, { Component } from 'react';
import { TrialOffer } from '../../templates';
import { withLanguageContext } from '../../../utils/LanguageContext';

/**
 * The trial offer section of the landing page.
 *
 * @typedef {Object} Props
 * @prop {Object} content
 *
 * @augments {Component<Props>}
 */
class TrialOfferView extends Component {

	render () {
		const {
			buttonLabel,
			content,
			heading,
			href,
			subheading,
		} = this.props.content.landingPage.trialOffer;

		return (
			<TrialOffer
				{...{
					buttonLabel,
					content,
					heading,
					href,
					subheading,
				}}
			/>
		);
	}

}

export default withLanguageContext(TrialOfferView);



// WEBPACK FOOTER //
// ./src/components/views/TrialOfferView/TrialOfferView.js